import { Typography } from "@packages/ds";
import styled from "styled-components";

import * as Sticker from "ds/Sticker";

export const ModalIntroText = styled(Typography.BodyText)`
  margin-top: 32px;
`;
export const RadioMainText = styled(Typography.BodyText)<{
  disabled?: boolean;
}>`
  ${({ disabled }) =>
    disabled &&
    `
   color: var(--label-granite-color,var(--granite));
  `}
`;
export const RadioGroupWrapper = styled.div`
  margin: 24px 0 20px;
`;

export const ActionWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
  margin-left: auto;
`;
export const StickerRoot = styled(Sticker.Root)`
  margin-top: 32px;
  margin-bottom: 0px;
`;
export const ModalDivider = styled.hr`
  background-color: var(
    --divider-periwinkle-grey-background-color,
    var(--periwinkle-grey)
  );
  width: 100%;
  margin: 0 0 24px 0;
`;
export const LoadingActionWrapper = styled.div`
  width: 108px;
  display: flex;
  justify-content: center;
`;

export const TitleTagWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const RadioDetails = styled.p<{ enabled?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: var(
    ${({ enabled }) =>
      enabled
        ? "--mode-text-neutral-weakest"
        : "--mode-text-neutral-weakest-disabled"}
  );
  margin: 0;
  line-height: 24px;
`;

export const MtcNote = styled.span`
  padding: 4px 8px;
  border-radius: var(--theme-br-tag);

  font-weight: 600;
  font-size: 12px;

  background-color: var(--mode-bg-primary-weak);
`;
